import { SET_DEVICE, SET_FISCAL_YEAR, SET_POPUP_MSG_MODEL } from './types'

const setDeviceStatus = payload => ({ type: SET_DEVICE, payload })

const setFiscalYear = payload => ({ type: SET_FISCAL_YEAR, payload })

const setPopupMessageModel = payload => ({ type: SET_POPUP_MSG_MODEL, payload })

export { setDeviceStatus, setFiscalYear, setPopupMessageModel }
